import { desarrolloLogic } from '../desarrollo/desarrollo.logic';
import { DesarrolloHostView, DesarrolloProjectorView, DesarrolloStudentView } from '../eval-blocks/EvalBlocksViews';
import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';

export const desarrolloPlugin: ActivityPlugin<'desarrollo'> = {
  ...desarrolloLogic,
  displayName: GAME_MODE_CATALOG.desarrollo.displayName,
  icon: GAME_MODE_CATALOG.desarrollo.icon,
  HostView: DesarrolloHostView,
  StudentView: DesarrolloStudentView,
  ProjectorView: DesarrolloProjectorView,
};

export { demoDesarrolloPayload } from '../desarrollo/desarrollo.logic';
